// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"229f903b","455":"9b10892e"}[chunkId] + ".chunk.js";
};